{
  "user-status-filter": {
    "label": "Користувачі:"
  },
  "slices-filter": {
    "label": "Вибір етапу:"
  },

  "reset-filters": "Скинути фільтри"
}
